export const statusColors = Object.freeze({
  AVAILABLE: 'rgb(19, 133, 77)',
  RING: '#e03623',
  RINGING: '#DB9513',
  PAUSE: '#002d80',
  UNPLACED: 'rgb(101, 112, 104)',
  ACTIVE_PAUSE: '#2365e0',
  TABULATION_PAUSE: '#f580f4',
  OFFLINE: 'rgb(101, 112, 104)',
  PARTIALLY_OCCUPIED: 'oklch(70.5% 0.213 47.604)',
  FULLY_OCCUPIED: 'oklch(63.7% 0.237 25.331)',
});
